import { Smartphone } from "lucide-react";
import AirtimeSummaryCards from "../components/AirtimeSummaryCards";
import AirtimeTopActions from "../components/AirtimeTopActions";
import AirtimeWalletAlert from "../components/AirtimeWalletAlert";
import AirtimeLoader from "../components/AirtimeLoader";
import { useAirtimeStats } from "../hooks";

export default function AirtimePortalPage() {
  const { data, isLoading } = useAirtimeStats();

  if (isLoading) return <AirtimeLoader />;

  if (!data) return null;

  return (
    <div className="min-h-screen bg-slate-50 p-6">
      <div className="mb-6 flex flex-col justify-between gap-4 xl:flex-row xl:items-center">
        <div className="flex items-center gap-3">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-emerald-100 text-emerald-700">
            <Smartphone className="h-5 w-5" />
          </div>
          <h1 className="text-3xl font-black text-slate-900">
            Airtime Portal
          </h1>
        </div>

        <AirtimeTopActions />
      </div>

      <AirtimeWalletAlert
        low={data.lowWalletBalance}
        balance={data.walletBalance}
      />

      <AirtimeSummaryCards stats={data} />
    </div>
  );
}
